import { For } from "solid-js";
import { creerApparence, MODES, PALETTES } from "../theme";

/** Palette et mode, réglés ici et gardés par le navigateur d'une visite à l'autre. */
export function ReglageApparence() {
  const { apparence, changer } = creerApparence();
  return (
    <section class="carte carte-parametre" aria-labelledby="reglage-apparence">
      <h2 id="reglage-apparence">Apparence</h2>
      <div class="apparence">
        <div class="apparence-ligne">
          <span class="intitule" id="apparence-palette">
            Couleurs
          </span>
          <div class="onglets onglets-petits" role="group" aria-labelledby="apparence-palette">
            <For each={PALETTES}>
              {(p) => (
                <button
                  type="button"
                  class="onglet"
                  classList={{ actif: apparence().palette === p.id }}
                  aria-pressed={apparence().palette === p.id}
                  onClick={() => changer({ palette: p.id })}
                >
                  {p.libelle}
                </button>
              )}
            </For>
          </div>
        </div>
        <div class="apparence-ligne">
          <span class="intitule" id="apparence-mode">
            Mode
          </span>
          <div class="onglets onglets-petits" role="group" aria-labelledby="apparence-mode">
            <For each={MODES}>
              {(m) => (
                <button
                  type="button"
                  class="onglet"
                  classList={{ actif: apparence().mode === m.id }}
                  aria-pressed={apparence().mode === m.id}
                  onClick={() => changer({ mode: m.id })}
                >
                  {m.libelle}
                </button>
              )}
            </For>
          </div>
        </div>
      </div>
    </section>
  );
}
